import React from 'react';
import { Box, Typography } from '@mui/material';

export default function FileTreeBadges({ latestFile, appliedFixes = {}, intentionalStaged = {} }) {
  const stagedEntry = latestFile ? (appliedFixes[(latestFile.path || latestFile.filename)] || null) : null;
  const stagedTokens = stagedEntry ? (Array.isArray(stagedEntry.tokens) ? stagedEntry.tokens : (stagedEntry.token ? [stagedEntry.token] : [])) : [];
  const stagedIntentionalArr = intentionalStaged[(latestFile?.path || latestFile?.filename)] || [];
  const stagedIntentionalCount = Array.isArray(stagedIntentionalArr) ? stagedIntentionalArr.length : 0;
  const hasUncommitted = (Array.isArray(stagedTokens) && stagedTokens.length > 0) || (stagedIntentionalCount > 0);
  const commentsArr = Array.isArray(latestFile?.comments) ? latestFile.comments : [];
  const hasComments = commentsArr.length > 0;
  const hasIntentionalCommitted = commentsArr.some(c => ((c.body || '').toString().toLowerCase().includes('marked intentional - ')));
  const stagedSetForChild = new Set((stagedIntentionalArr || []).map(v => (typeof v === 'string' ? parseInt(v, 10) : v)).filter(Number.isFinite));
  const hasUnfixed = commentsArr.some(c => { const b = (c.body || '').toString().toLowerCase(); const tidRaw = (c && (c.thread_id ?? c.threadId ?? c.ThreadID)); const tid = typeof tidRaw === 'string' ? parseInt(tidRaw, 10) : tidRaw; const isStagedIntentional = Number.isFinite(tid) && stagedSetForChild.has(tid); return !b.includes('fixed - ') && !b.includes('marked intentional - ') && !isStagedIntentional; });
  const isAllFixed = hasComments && commentsArr.every(c => ((c.body || '').toString().toLowerCase().includes('fixed - ')));
  const showGreen = isAllFixed || (hasIntentionalCommitted && !hasUnfixed);
  return (
    <>
      {hasIntentionalCommitted && (<Box component="span" sx={{ ml: 0.75, width: 8, height: 8, borderRadius: '50%', backgroundColor: '#f0ad36' }} />)}
      {hasUnfixed && (<Box component="span" sx={{ ml: 0.75, width: 8, height: 8, borderRadius: '50%', backgroundColor: '#f85149' }} />)}
      {showGreen && (<Box component="span" sx={{ ml: 0.75, width: 8, height: 8, borderRadius: '50%', backgroundColor: '#3fb950' }} />)}
      {hasUncommitted && (<Typography component="span" sx={{ ml: 1, color: '#7ee787', fontWeight: 700, fontSize: '12px', lineHeight: 1 }}>M</Typography>)}
    </>
  );
}



